import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * Absolute date and time in the interface language. The previous inline version
 * hardcoded ja-JP, so English users saw Japanese-formatted timestamps.
 */
export function useDateTimeFormat() {
  const { i18n } = useTranslation();
  const locale = i18n.language?.startsWith('ja') ? 'ja-JP' : 'en-US';

  return useCallback(
    (value?: string | null): string => {
      if (!value) return '—';
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString(locale, OPTIONS);
    },
    [locale],
  );
}
